import { getXAuthInfoHeader } from 'utils/auth';

// API Configuration for both development and production
const getApiBaseUrl = () => {
  // // In development, use the Vite dev server which proxies to Strapi
  // if (import.meta.env.DEV) {
  //   return ''; // Empty string means use relative URLs (Vite proxy will handle it)
  // }

  // // In production, use the full URL
  return import.meta.env.VITE_CMS_BASEURL || 'https://content.srx.id';
};

export const API_BASE_URL = getApiBaseUrl();
export const CMS_API_TOKEN = import.meta.env.VITE_CMS_API_TOKEN;

// Helper function to create API headers
export const createApiHeaders = (
  additionalHeaders: Record<string, string> = {}
): Record<string, string> => {
  const xAuthInfoHeader = getXAuthInfoHeader();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...xAuthInfoHeader,
    ...additionalHeaders,
  };

  if (CMS_API_TOKEN) {
    headers['Authorization'] = `Bearer ${CMS_API_TOKEN}`;
  }

  return headers;
};

// Helper function to determine the correct URL for different endpoint types
const getApiUrl = (endpoint: string): string => {
  // // In development, use relative URLs (Vite proxy handles routing)
  // if (import.meta.env.DEV) {
  //   // All Strapi REST API endpoints must have /api prefix
  //   if (!endpoint.startsWith('/api/')) {
  //     return `/api${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
  //   }
  //   return endpoint;
  // }

  // In production, all endpoints need /api prefix
  if (!endpoint.startsWith('/api/')) {
    return `${API_BASE_URL}/api${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
  }

  return `${API_BASE_URL}${endpoint}`;
};

// Helper function to make API requests
export const apiRequest = async (
  endpoint: string,
  options: RequestInit = {}
): Promise<Response> => {
  const url = getApiUrl(endpoint);
  const headers = createApiHeaders(
    (options.headers as Record<string, string>) || {}
  );

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const errorText = await response.text();
    let errorMessage = `API request failed: ${response.status} ${response.statusText}`;
    try {
      const parsed = JSON.parse(errorText);
      if (parsed?.error?.message) {
        errorMessage = parsed.error.message;
      }
    } catch {
      if (errorText) {
        errorMessage += `. ${errorText}`;
      }
    }
    throw new Error(errorMessage);
  }

  return response;
};
